import { EpimsBaseEntityDto } from './epim-base.dto';
export class RateStatusDto extends EpimsBaseEntityDto {
  RateStatusName: string;
  SubscriptionUserId: string;
  Version: number;
}
